import Cookies from 'js-cookie';

// Import helpers
import { getUserAgent } from 'helpers';
import { OPERATORS } from 'helpers/operators';

// Import helpers
import { ERROR_CODE_API_TYPES } from 'helpers/error_code_api';

const {
	MULTIPLE_ACCOUNT_AVAILABLE,
	UNRELATED_PROVIDER_ERROR_MESSAGE
} = ERROR_CODE_API_TYPES;
const { RETAIL } = OPERATORS;

export const checkAuthorizationError = ({ response }) => {
	const errorStatus = response?.status;
	const data = response?.data;
	const statusCode = data?.status?.code;
	const isMultipleAccount = statusCode === MULTIPLE_ACCOUNT_AVAILABLE;
	const isExternalProviderError =
		data.errorCode === UNRELATED_PROVIDER_ERROR_MESSAGE;
	const isAuthorizationError = errorStatus !== 409;
	return {
		data,
		isMultipleAccount,
		isAuthorizationError,
		isExternalProviderError
	};
};

export const getInitialValues = () => {
	const { browser, os } = getUserAgent();
	const uid = Cookies.get('uid');
	const systems =
		process.env.REACT_APP_OPERATOR === RETAIL
			? {
					system: process.env.REACT_APP_SYSTEM,
					source: process.env.REACT_APP_SYSTEM
			  }
			: {};

	return {
		...systems,
		os: os.name,
		osVersion: os.version,
		maker: 'unknown',
		agent: browser.name,
		uid
	};
};
